export default class Toggle {
  /**
   * Create new toggle
   * @param {HTMLElement} button Toggle button
   */
  constructor (button, options = {}) {
    this.button = button
    this.element = document.querySelector(button.dataset.toggle)
    this.onShow = options.onShow
    this.onHide = options.onHide
  }

  /**
   * Initialize toggle
   */
  init () {
    this.button.addEventListener('click', event => {
      event.preventDefault()
      this.toggle()
    })
  }

  /**
   * Show element
   */
  show () {
    this.element.classList.add('is-visible')
    this.element.setAttribute('aria-hidden', 'false')

    if (typeof this.onShow === 'function') {
      this.onShow(this.button, this.element)
    }
  }

  /**
   * Hide element
   */
  hide () {
    this.element.classList.remove('is-visible')
    this.element.setAttribute('aria-hidden', 'true')

    if (typeof this.onHide === 'function') {
      this.onHide(this.button, this.element)
    }
  }

  /**
   * Toggle between shown and hidden
   */
  toggle () {
    if (this.element.classList.contains('is-visible')) {
      this.hide()
    } else {
      this.show()
    }
  }
}

const buttons = document.querySelectorAll('.js-toggle-element')
buttons.forEach(button => new Toggle(button).init())
